import React from "react";
import styles from "assets/jss/material-dashboard-react/components/tablebaocaoStyle.js";
const useStyles = makeStyles(styles);
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
const BCVantaitable = React.memo(function BCVantaitable(props) {
  const classes = useStyles();
  const { data } = props;
  const renderTableHead = () => {
    return (
      <thead>
        <tr>
          <th className={classes.tablebc_th}>TT</th>
          <th className={classes.tablebc_th}>Chỉ tiêu</th>
          <th className={classes.tablebc_th}>Đơn vị</th>
          <th className={classes.tablebc_th}>Số lượng</th>
        </tr>
      </thead>
    );
  };
  const renderTableBody = () => {
    return (
      <tbody>
        <tr>
          <td className={classes.tablebc_td}>1</td>
          <td className={classes.tablebc_td}>Số lượng phương tiện</td>
          <td className={classes.tablebc_td}>xe</td>
          <td className={classes.tablebc_td}>{data.tong_sophuongtien}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}></td>
          <td className={classes.tablebc_td}>- Xe công-ten-nơ</td>
          <td className={classes.tablebc_td}>xe</td>
          <td className={classes.tablebc_td}>{data.socontainer}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}></td>
          <td className={classes.tablebc_td}>- Xe đầu kéo</td>
          <td className={classes.tablebc_td}>xe</td>
          <td className={classes.tablebc_td}>{data.sodaukeo}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}></td>
          <td className={classes.tablebc_td}>- Xe taxi tải</td>
          <td className={classes.tablebc_td}>xe</td>
          <td className={classes.tablebc_td}>{data.sotaxitai}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}></td>
          <td className={classes.tablebc_td}>- Xe tải khác</td>
          <td className={classes.tablebc_td}>xe</td>
          <td className={classes.tablebc_td}>{data.soxetai}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>2</td>
          <td className={classes.tablebc_td}>Sản lượng hàng hóa vận chuyển</td>
          <td className={classes.tablebc_td}>tấn</td>
          <td className={classes.tablebc_td}>{data.tong_slvanchuyen}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}></td>
          <td className={classes.tablebc_td}>- Xe công-ten-nơ</td>
          <td className={classes.tablebc_td}>tấn</td>
          <td className={classes.tablebc_td}>{data.slvanchuyen_container}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}></td>
          <td className={classes.tablebc_td}>- Xe đầu kéo</td>
          <td className={classes.tablebc_td}>tấn</td>
          <td className={classes.tablebc_td}>{data.slvanchuyen_daukeo}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}></td>
          <td className={classes.tablebc_td}>- Xe taxi tải</td>
          <td className={classes.tablebc_td}>tấn</td>
          <td className={classes.tablebc_td}>{data.slvanchuyen_taxitai}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}></td>
          <td className={classes.tablebc_td}>- Xe tải khác</td>
          <td className={classes.tablebc_td}>tấn</td>
          <td className={classes.tablebc_td}>{data.slvanchuyen_tai}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>3</td>
          <td className={classes.tablebc_td}>Sản lượng luân chuyển hàng hóa</td>
          <td className={classes.tablebc_td}>tấn.km</td>
          <td className={classes.tablebc_td}>{data.tong_slluanchuyen}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}></td>
          <td className={classes.tablebc_td}>- Xe công-ten-nơ</td>
          <td className={classes.tablebc_td}>tấn.km</td>
          <td className={classes.tablebc_td}>{data.slluanchuyen_container}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}></td>
          <td className={classes.tablebc_td}>- Xe đầu kéo</td>
          <td className={classes.tablebc_td}>tấn.km</td>
          <td className={classes.tablebc_td}>{data.slluanchuyen_daukeo}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}></td>
          <td className={classes.tablebc_td}>- Xe taxi tải</td>
          <td className={classes.tablebc_td}>tấn.km</td>
          <td className={classes.tablebc_td}>{data.slluanchuyen_taxitai}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}></td>
          <td className={classes.tablebc_td}>- Xe tải khác</td>
          <td className={classes.tablebc_td}>tấn.km</td>
          <td className={classes.tablebc_td}>{data.slluanchuyen_tai}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>4</td>
          <td className={classes.tablebc_td}>Doanh thu</td>
          <td className={classes.tablebc_td}>Tr.đ</td>
          <td className={classes.tablebc_td}>{data.doanhthu}</td>
        </tr>
      </tbody>
    );
  };
  var tHead = renderTableHead();
  var tBody = renderTableBody();
  return (
    <div>
      <table className={classes.tablebc}>
        {tHead}
        {tBody}
      </table>
    </div>
  );
});

BCVantaitable.propTypes = {
  data: PropTypes.object,
};
export default BCVantaitable;
